import { Helmet } from "react-helmet-async";

interface SEOProps {
  title: string;
  description: string;
  path: string; // e.g. "/login"
}

/**
 * Per-route head tags. Overrides the sitewide tags in index.html for
 * JS-executing crawlers (Googlebot). Social-preview crawlers that don't
 * run JS fall back to the static tags in index.html.
 */
const SEO = ({ title, description, path }: SEOProps) => {
  const url = `https://talklot.site${path}`;
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
    </Helmet>
  );
};

export default SEO;
